import Barba from 'barba.js'

export default Barba.BaseView.extend({
    namespace: 'support',
    onEnter() {
        if( document.querySelector('.loader') ) {
            Barba.Dispatcher.on('pageLoading', () => {
                Barba.Pjax.Manager.getAnimationManager().get('intro').play()
            } )
        }
    },
    onEnterCompleted() {
        if( ! document.querySelector('.loader') || ! this.played ) {
            Barba.Pjax.Manager.getAnimationManager().get('intro').play()
        }

        if( ! document.querySelector('.skype-script') ) {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.classList.add('skype-script');
            script.src = 'https://latest-swc.cdn.skype.com/sdk/v1/sdk.min.js';
            document.body.appendChild( script )
        }
    },
    onLeave() {
        let scripts = document.querySelectorAll('script');
        scripts.forEach( e => {
            if( e.src.includes( 'latest-swc' ) ) e.remove();
        });

        if( document.querySelector( '#swc-services' ) ) document.querySelector( '#swc-services' ).remove();
        if( document.querySelector('.skype-chat') ) document.querySelector('.skype-chat').remove()
    },
    onLeaveCompleted() {
    }
})